import css from 'styled-jsx/css'
import { colors, fontSizes, fontWeights, measurements, designatedColors } from 'theme'

export default css`
  .wrapper-card.card-title {
    margin-bottom: 0rem;
    text-align: left;
    border-bottom: 1px solid ${colors.border};
    font-size: ${fontSizes.h5};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .wrapper-card.card-title.bordered {
    border: 1px solid ${colors.border};
    border-bottom: none;
  }
  .wrapper-card.card-title.borderedDashed {
    border: 1px dashed ${colors.border};
    border-bottom: none;
  }
  .wrapper-card.card-title .action {
    max-width: 12rem;
    width: 12rem;
    display: flex;
    justify-content: flex-end;
  }

  .wrapper-card {
    background-color: ${colors.white};
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-items: stretch;
    /* justify-content: center;
    text-align: center; */

    width: 100%;
    max-width: ${measurements.containerSize};
    margin-bottom: 1rem;
    transition: all 0.3s;
    margin-right: auto;
    margin-left: auto;
  }
  .wrapper-card.alignCenter {
    justify-content: center;
    text-align: center;
  }
  .wrapper-card.alignRight {
    justify-content: flex-end;
    text-align: right;
  }
  .wrapper-card.alignLeft {
    justify-content: flex-start;
    text-align: left;
  }
  .wrapper-card.shadow {
    box-shadow: 0 0 20px 0 ${colors.alpha(colors.boxShadowGray, 0.5)};
  }
  .wrapper-card.bordered {
    border: 1px solid ${colors.border};
  }
  .wrapper-card.borderedDashed {
    border: 1px dashed ${colors.border};
  }
  .wrapper-card.success,
  .wrapper-card.card-title.success {
    color: ${colors.primary};
    border: 1px solid ${colors.primary};
    background-color: ${colors.alpha(colors.primary, 0.3)};
  }
  .wrapper-card.card-title.success :global(i) {
    color: ${colors.primary};
  }
  .wrapper-card.warning,
  .wrapper-card.card-title.warning {
    color: ${colors.white};
    background-color: ${colors.warning};
    border: none;
  }

  .wrapper-card.card-title.warning :global(i) {
    color: ${colors.badge};
  }
  .wrapper-card.error,
  .wrapper-card.card-title.error {
    border: 1px solid ${colors.danger};
  }
  .wrapper-card.enableHover:hover,
  .wrapper-card.shadow:hover {
    box-shadow: 0 11px 29px 8px ${colors.boxShadow};
  }
  .wrapper-card.gray {
    background-color: ${designatedColors.cardGray};
  }
  .wrapper-card.noPadding {
    padding: 0rem;
  }
  .wrapper-card.small {
    padding: 0.5rem;
  }
  .wrapper-card.fat,
  .wrapper-card.titleFat {
    padding: 2rem;
  }
  .wrapper-card.card-title.success,
  .wrapper-card.card-title.warning,
  .wrapper-card.card-title.error {
    border-bottom: none;
  }

  .wrapper-card.rounded {
    border-radius: ${measurements.borderRadius};
  }
  .wrapper-card.card-title.rounded {
    border-radius: ${measurements.borderRadius} ${measurements.borderRadius} 0 0;
  }
  .wrapper-card.card-title.rounded ~ .wrapper-card.rounded {
    border-radius: 0 0 ${measurements.borderRadius} ${measurements.borderRadius};
  }

  .wrapper-card.card-title.without-border,
  .wrapper-card.without-border {
    border: none;
  }

  @media screen and (max-width: 992px) {
    .wrapper-card.fat,
    .wrapper-card.titleFat {
      padding: 1rem;
    }
    .wrapper-card {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }

  @media screen and (min-width: 1200px) {
    .wrapper-card {
      max-width: ${measurements.containerLargeSize};
    }
  }

  @media screen and (max-width: 548px) {
    .wrapper-card.card-title {
      flex-direction: column;
    }
    .wrapper-card.card-title .action {
      max-width: 100%;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
`

export const cardWithIconStyle = css`
  .content-card-icon .title {
    margin: 1rem 0.5rem 0.5rem;
    font-weight: ${fontWeights.semiBold};
  }
`

export const closabledCardStyle = css`
  .closabled-card {
    position: relative;
  }
  .closabled-card :global(.wrapper-card) {
    padding-right: 2rem;
  }
  .closabled-card :global(.closabled-card-button) {
    position: absolute;
    top: 0;
    right: 0;
  }
`
